import script from "./EditEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./EditEvento.vue?vue&type=script&setup=true&lang=js"

import "./EditEvento.vue?vue&type=style&index=0&id=16f32d63&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f32d63"]])

export default __exports__